<template>
  <div id="main-video" @mouseover="hoveredVideo=true" @mouseleave="hoveredVideo=false">
    <!--    <div class="wistia_embed wistia_async_17ct2s0bnx popover=true popoverAnimateThumbnail=true popoverContent=link"-->
    <!--         style="display:inline;position:relative">-->
    <!--    </div>-->
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Video',
  data() {
    return {
      hoveredVideo: false,
      isVideoEnd: false,
      isResetVideo: true,
      scrolledFromTop: 0,
      modalCheckInterval: null
    };
  },
  computed: {
    ...mapState([
      'userAgent', 'timeProgress'
    ]),
    isIE() {
      return this.userAgent.browser.name === 'ie';
    },
  },
  methods: {
    stopVideo() {
      // this.$store.commit('VIDEO_STATE', false);
    },
    resetVideo(video) {
      if (this.isResetVideo && !this.$route.query.screentest && video.time()) {
        video.time(0);
        video.unmute();
        this.isResetVideo = false;
      }
    }
  },
  created() {
  },
  mounted() {
    let thisIs = this;
    window._wq = window._wq || [];
    _wq.push({
      id: '_all',
      onReady: (video) => {
        this.scrolledFromTop = window.scrollY;
        thisIs.resetVideo(video);
        video.bind('play', () => {
          thisIs.resetVideo(video);
          this.$store.commit('TOGGLE_VIDEO', true);
          if (!thisIs.isVideoEnd && thisIs.timeProgress >= 0) {
            // video.time(this.timeProgress);
            this.$store.commit('SET_VIDEO_PROGRESS', 0);
          } else {
            // video.time(0);
            this.$store.commit('SET_VIDEO_PROGRESS', 0);
          }
        });
        video.bind("timechange", () => {
          if(this.userAgent.orientation === 'landscape' && video.state() === "playing") {
            video.requestFullscreen()
          }
          window.scrollTo(0, this.scrolledFromTop);
        });
        video.bind('pause', () => {
          this.$store.commit('TOGGLE_VIDEO', false);
          thisIs.stopVideo();
        });
        video.bind('end', function (t) {
          this.$store.commit('TOGGLE_VIDEO', false);
          thisIs.isVideoEnd = true;
          thisIs.stopVideo();
        });
        video.bind("cancelfullscreen", () => {
          window.scrollTo(0, this.scrolledFromTop);
        });
        video.bind("beforeremove", () => {
          window.scrollTo(0, this.scrolledFromTop);
        });
      }
    });

    const modalDiv = document.querySelector('.sweet-modal-overlay');
    if (modalDiv) {
      this.modalCheckInterval = setInterval(() => {
        if (!modalDiv.classList.contains('is-visible')) {
          this.scrolledFromTop = window.scrollY;
        }
      },500)
    }
  },
  beforeDestroy() {
    if (this.modalCheckInterval) clearInterval(this.modalCheckInterval);
  },
  watch: {
    $route(to, from) {
      this.isResetVideo = true;
    }
  }
};
</script>

<style lang="scss"></style>
